import React, { useState } from 'react';
import SplitReport from './SplitReport';
import SplitConfig from './SplitConfig';

const SplitPayment = () => {
  const [activeTab, setActiveTab] = useState('report'); // 'report' or 'config'

  return (
    <div className="min-h-screen bg-[#f7f6f3]">
      <style>{`
        .tab-nav {
          background: #ffffff;
          border-bottom: 1px solid #e2e0d8;
          padding: 0 40px;
          display: flex;
          align-items: center;
          height: 60px;
          position: sticky;
          top: 0;
          z-index: 100;
          font-family: 'Lato', sans-serif;
        }
        .nav-brand {
          font-family: 'Lato', sans-serif;
          font-size: 1.15rem;
          font-weight: 900;
          display: flex;
          align-items: center;
          gap: 8px;
          margin-right: 40px;
          color: #030229;
        }
        .nav-brand .dot {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #f58220;
        }
        .tab-btn {
          padding: 7px 14px;
          border-radius: 8px;
          font-size: 0.83rem;
          font-weight: 500;
          color: #8888aa;
          background: none;
          border: none;
          cursor: pointer;
          transition: all 0.15s;
          font-family: 'Lato', sans-serif;
        }
        .tab-btn:hover {
          background: #f0efe9;
          color: #4a4a6a;
        }
        .tab-btn.active {
          background: #fff4e6;
          color: #f58220;
          font-weight: 600;
        }
      `}</style>

      <div className="tab-nav">
        <div className="nav-brand">
          <span className="dot"></span> Split Pay
        </div>
        <div className="flex gap-2">
          <button
            className={`tab-btn ${activeTab === 'report' ? 'active' : ''}`}
            onClick={() => setActiveTab('report')}
          >
            Reporting
          </button>
          <button
            className={`tab-btn ${activeTab === 'config' ? 'active' : ''}`}
            onClick={() => setActiveTab('config')}
          >
            Configuration
          </button>
        </div>
      </div>

      <div className="tab-content">
        {activeTab === 'report' ? <SplitReport /> : <SplitConfig />}
      </div>
    </div>
  );
};

export default SplitPayment;
